export default __webpack_public_path__ + "static/media/s8.1f173237.png";